module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00089.4470b08f.jpg";